import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=1c3c1e94&scoped=true"
import script from "./Feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=1c3c1e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c1e94",
  null
  
)

export default component.exports